import type { SxProps, Theme } from '@mui/material/styles';

export const pageSizeArrowIconSx: SxProps<Theme> = {
  fontSize: '20px',
  color: '#807D93',
  ml: '4px',
};

export const pageSizeMenuPaperSx: SxProps<Theme> = {
  minWidth: 100,
};

export const paginationInfoPillSx: SxProps<Theme> = {
  gap: '12px',
};

export const rightSectionSx: SxProps<Theme> = {
  gap: '0.5rem',
};

export const stackedFooterSx: SxProps<Theme> = {
  flexDirection: 'column',
  alignItems: 'stretch',
  justifyContent: 'flex-start',
  gap: '1.125rem',
  // Without this a wide actions row stretches the footer past the dialog instead of clipping.
  minWidth: 0,
};

export const paginationRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '0.625rem',
};

export const actionsRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: '1rem',
  minWidth: 0,
};
